module.exports = "/dashboard/manage/users/selfInvite/selfInviteEmptyListComponent-65ddc7.html";